'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { CRYPTO_LOGOS, PAYMENT_METHOD_LOGOS, PaymentLogo } from '@/constants';
import { usePaymentMethodPages } from '@/src/hooks/usePaymentMethodPages';
import styles from './PaymentMethodsGrid.module.css';

const PaymentMethodsGrid: React.FC = () => {
  const { getPageHref } = usePaymentMethodPages();

  const renderLogo = (logo: PaymentLogo, className: string, width: number, height: number) => {
    const href = getPageHref(logo);
    const image = (
      <Image src={`/logos/${logo.file}`} width={width} height={height} loading="lazy" alt={`${logo.name} logo`} unoptimized />
    );

    if (!href) {
      return (
        <div key={logo.name} className={className} title={logo.name}>
          {image}
        </div>
      );
    }

    return (
      <Link
        key={logo.name}
        href={href}
        className={`${className} ${styles.linkedLogoBox}`}
        title={logo.name}
        aria-label={`Buy gift cards with ${logo.name}`}
        prefetch={false}
      >
        {image}
      </Link>
    );
  };

  return (
    <div className={styles.logosContainer}>
      {CRYPTO_LOGOS.map((logo) => renderLogo(logo, styles.cryptoLogoBox, 70, 70))}
      {PAYMENT_METHOD_LOGOS.map((logo) => renderLogo(logo, styles.paymentLogoBox, 140, 70))}
    </div>
  );
};

export default PaymentMethodsGrid;
